import { gql } from '@apollo/client';

export const GET_FINAL_EXAM_BY_ID = gql`
  query GetFinalExamById($id: ID!) {
    getFinalExamById(id: $id) {
      id
      userId
      tags
      userQuestions {
        questionId
        question {
          id
          prompt
          options {
            desc
            isAnswer
          }
          explanation
          tag
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      createdAt
      updatedAt
    }
  }
`;
